import { configureStore, combineReducers } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import toolbarReducer from './features/toolbarSlice';
import networkReducer from './features/networkSlice';
import networkUndoReducer from './features/networkUndoSlice';

// reducers
const reducers = combineReducers({
  networkUndo: undoable(networkUndoReducer, { debug: false, limit: 20 }),
  network: networkReducer,
  toolbar: toolbarReducer,
});

// persistence
const persistConfig = {
  key: 'root',
  storage,
};
const persistedReducer = persistReducer(persistConfig, reducers);

// store
const store = configureStore({
  // reducer: reducers,
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

export default store;
